import { UserModule } from "@/store/modules/user";
/**
 * 发布事件
 * @param el 发布对象
 * @param type 事件名
 */
const trigger = (el, type) => {
    // const e: Event = document.createEvent("HTMLEvents");
    // e.initEvent(type, true, true);
    // Event.initEvent()已被弃用, 重构为Event构造函数
    const e = new Event(type);
    el.dispatchEvent(e);
};
/**
 * 权限校验
 * @param permission 权限名
 * @returns 是否授权
 */
const hasPermission = (permission) => {
    const pList = UserModule.permissions;
    return pList.includes(permission);
};
const directives = {
    /**
     * 用以限制input元素只能输入数字类型 支持修饰符
     * int：整数型(首位不能为零)
     * float：小数型(传参控制小数位)
     */
    number: {
        inserted(el, binding) {
            let input;
            if (el.tagName === "input") {
                input = el;
            }
            else {
                input = el.getElementsByTagName("input")[0];
            }
            if (!input)
                return;
            // 检测输入法
            let flag = true;
            input.addEventListener("compositionstart", () => {
                flag = false;
            });
            input.addEventListener("compositionend", () => {
                flag = true;
            });
            input.onkeyup = function () {
                if (!flag)
                    return;
                const modifiers = binding.modifiers;
                const oriValue = input.value;
                let newValue = "";
                if (modifiers.float) {
                    // 如未传参则默认小数位为2
                    const fractionDigits = binding.value || 2;
                    const reg = fractionDigits === 0
                        ? `^[\\+\\-]?\\d+`
                        : `^[\\+\\-]?\\d+\\.?\\d{0,${fractionDigits}}`;
                    const res = input.value.match(new RegExp(reg, "g"));
                    newValue = (res && res[0]) || "";
                }
                else if (modifiers.int) {
                    if (oriValue.length === 1) {
                        newValue = oriValue.replace(/[^0-9]/g, "");
                    }
                    else {
                        newValue = oriValue.replace(/[^\d]/g, "");
                        if (newValue[0] === "0")
                            newValue = newValue.substr(1);
                    }
                }
                else {
                    // 没有修饰符则默认位纯数字
                    newValue = oriValue.replace(/[^\d]/g, "");
                }
                if (oriValue === newValue)
                    return;
                input.value = newValue;
                trigger(input, "input");
            };
        },
    },
    // 用以dom元素鉴权 例如v-permission="edit"
    permission: {
        inserted(el, binding) {
            const permission = binding.value;
            // 校验是否授权 如未获得授权移除当前dom元素
            if (!hasPermission(permission)) {
                el.remove();
            }
        },
    },
};
export default directives;
